enum TripStatus {
  ABORTED = "aborted",
  ACTIVE = "active",
  COMPLETED = "completed",
}

export default TripStatus;
